import React from 'react';
import { WrapModal } from './styles';
import { Container, Layer } from './components';
import { GlobalStyles } from '../LightBox';

const Modal = (props: any) => {
  const { children, handleCloseModal, IsModalOpen, buttonClose } = props;
  return (
    <WrapModal className={`${IsModalOpen ? 'active' : ''}`}>
      {IsModalOpen ? <GlobalStyles /> : <div />}

      <Layer handleClose={handleCloseModal} />
      <Container buttonClose={buttonClose} handleClose={handleCloseModal}>
        {children}
      </Container>
    </WrapModal>
  );
};

export default Modal;
